import { gridDataSource, columnData } from './scorecard-projects-data';

function getCompany() {
    return (
        $('#viewLevel').val() ||
        $('#changeCompany--js')
            .find('a.menu-settings__link--active')
            .attr('data-value')
    );
}

let gridHeight = 200;
let gridExists = false;
let isLoading = false;

function toggleActive(b) {
    const activeTab = $('a.menu-topbar__link.--active').text();
    const activePane = $(`.sparklines[data-view="${activeTab}"]`);
    activePane.toggle(b);
}

export default function($el) {
    gridDataSource.bind('requestEnd', createGrid);
    gridDataSource.read();

    function resetGrid() {
        const { id } = $el[0];
        const top = $el.parents('.grid--scorecard');
        const newDiv = document.createElement('div');
        newDiv.id = id;
        $el.empty();
        top.empty();
        $el = $(newDiv);
        top.append(newDiv);
    }

    function removeGridTemplates() {
        $('.scorecard__popup-content.k-reset').remove();
    }

    function destroyGrid() {
        $('#noDataMsg').remove();
        const grid = $el.data('kendoGrid');
        $('#scorecardLoading').toggle(true);
        if (!gridExists) return;
        grid.destroy();
        resetGrid();
        removeGridTemplates();
        gridExists = false;
    }

    $('#scorecardFilter').on('click', () => {
        isLoading = true;
        destroyGrid();
        triggerScorecardLoad();
        gridDataSource.read();
    });

    function noDataMessage(arg) {
        const msg = document.createElement('div');
        msg.id = 'noDataMsg';
        $(msg).text('No project(s) match the selected criteria.');
        $el.append(msg);
        $('#scorecardLoading').toggle(false);
        toggleActive(false);
    }

    function createGrid(e) {
        if (e.response === undefined || e.response.length === 0) return noDataMessage(e);
        gridExists = true;
        try {
            const grid = $el.kendoGrid({
                autoBind: false,
                dataSource: gridDataSource,
                mobile: 'phone',
                resizable: false,
                height: gridHeight, // Nudging to the table content
                columns: columnData.slice().reverse(),
                dataBound: onDataBound
            });
            const tabName = $('a.menu-topbar__link.--active')[0].text;
            $(document).trigger('on:RenderSparklines', [{ tabName }]);
            return grid;
        } catch {
            return noDataMessage(e);
        }
    }

    const $vl = $('#viewLevel').data('kendoDropDownList');
    const $pm = $('#projectManager').data('kendoAutoComplete');
    const $p = $('#project').data('kendoAutoComplete');
    let pm = {};
    $pm.bind('select', e => {
        pm = e.dataItem.value;
        $p.dataSource.read();
    });
    $pm.dataSource.transport.parameterMap = (data, type) => {
        if (type === 'read') {
            const extra = {};
            extra.company = getCompany();
            return $.extend(data, extra);
        }
        return data;
    };
    $p.dataSource.transport.parameterMap = (data, type) => {
        if (type === 'read') {
            const extra = {};
            extra.company = getCompany();
            extra.teamMember = pm;
            return $.extend(data, extra);
        }
        return data;
    };
    $vl.bind('change', function() {
        $pm.element.val('');
        $p.element.val('');
        $pm.dataSource.read();
        $p.dataSource.read();
    });

    const menuBase = $('a.menu-topbar__link');
    menuBase.click(function(e) {
        if (isLoading) {
            e.preventDefault();
            return 0;
        }
        isLoading = true;
        triggerScorecardLoad();
        const that = $(this);
        const subject = that.text();
        const parents = menuBase.parent();
        const thoseParents = that.parent();
        menuBase.removeClass('--active');
        menuBase.prop('disabled', true);
        parents.removeClass('--active');
        that.addClass('--active');
        thoseParents.addClass('--active');
        const subjectPanes = $('.sparklines[data-view]');
        subjectPanes.each(function() {
            const pane = $(this);
            const paneSubject = pane.attr('data-view');
            const toggle = paneSubject === subject;
            pane.toggle(toggle);
            if (toggle) {
                gridHeight = paneSubject.includes('PCO') ? 175 : 200;
            }
        });
        destroyGrid();
        gridDataSource.read();
        $('#menu-topbar__label').text(subject); // Mobile button label text
        return 1;
    });

    menuBase.not('a.menu-topbar__link.--active').each(function() {
        const that = $(this);
        const subject = kendo.htmlEncode(that.text());
        const subjectPanes = $(`.sparklines[data-view="${subject}"]`);
        subjectPanes.toggle(false);
    });
}

function scorecardPopup() {
    const $popupToggle = $('.scorecard__popup-toggle');
    if ($popupToggle.length) {
        $popupToggle.each(function(i) {
            const toggle = $(this);
            const popup = toggle.next();
            const anchor = toggle;

            popup.kendoPopup({
                anchor,
                origin: 'top right',
                collision: 'fit',
                animation: {
                    open: {
                        effects: 'fade:in'
                    }
                }
            });

            toggle.click(() => popup.data('kendoPopup').toggle());
        });
    }
}

function triggerScorecardLoad() {
    const activeTab = $('a.menu-topbar__link.--active')[0].text;
    $(document).trigger('on:ScorecardDataStart', [{ tabName: activeTab }]);
}

function assignStatus() {
    const $cells = $('.grid-cell--status');
    if ($cells.length) {
        $cells.each(function(i) {
            const cell = this;
            const statusNum = cell.getAttribute('data-status');
            let statusClass = '';
            if (statusNum == null) statusClass = '--blank';
            if (statusNum == 1) statusClass = '--pass';
            if (statusNum == 2) statusClass = '--warning';
            if (statusNum == 3) statusClass = '--fail';
            if (statusClass.length) cell.classList.add(statusClass);
        });
    }
}

function onDataBound(arg) {
    isLoading = false;
    $('#scorecardLoading').toggle(false);
    toggleActive(true);
    const thatSource = arg.sender.dataSource;
    if (thatSource.total() !== 0) {
        assignStatus();
        scorecardPopup();
    }
}
